module.exports = require('./multiply');